import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FlightScheduleDTO } from 'src/app/planner/dto/FlightScheduleDTO';
import * as _ from 'lodash';
import { AdvertiserInfoVO } from '../../../interfaces/AdvertiserInfo';
import { BudgetingService } from '../../../services/budgeting.service';
import { PlannerConstants } from 'src/app/planner/constants/planner.const';

@Component({
  selector: 'budget-flight-schedule',
  templateUrl: './budget-flight-schedule.component.html',
  styleUrls: ['./budget-flight-schedule.component.scss']
})
export class BudgetFlightScheduleComponent implements OnInit {
  @Input() group: string;
  @Input() formArray: FormArray;
  @Input() isNew: boolean;
  @Input() advertiserInfo: AdvertiserInfoVO;
  readonly budgetLimit = PlannerConstants.BUDGET_LIMIT;
  selectedStartDate: FormControl = new FormControl({});
  selectedEndDate: FormControl = new FormControl({});
  currencySymbol: string = '';

  removeBudgetFlightSchedule: boolean = false;

  constructor(
    private fb: FormBuilder,
    private budgetingService: BudgetingService
  ) {
  }

  ngOnInit() {
    if (!this.isNew && this.advertiserInfo.marketTimeZone) {
      this.selectedStartDate.patchValue({ date: this.budgetingService.convertFromLocalTime(this.startDate.value, this.advertiserInfo.marketTimeZone, 'startDate').getTime() / 1000 });
      this.selectedEndDate.patchValue({ date: this.budgetingService.convertFromLocalTime(this.endDate.value, this.advertiserInfo.marketTimeZone, 'endDate').getTime() / 1000 });
    }
    if (this.flightSchedule.disabled) {
      this.selectedStartDate.disable();
      this.selectedEndDate.disable();
    }
    if (this.advertiserInfo.currency) {
      this.currencySymbol = this.budgetingService.getCurrencyAbbrevWithSymbol(this.advertiserInfo.currency);
    }
  }

  setStartDate(event) {
    let localDate = this.budgetingService.convertToLocalTime(event.date * 1000, this.advertiserInfo.marketTimeZone, 'startDate');
    this.startDate.patchValue(localDate);
    if (!this.startDate.touched) {
      this.startDate.markAsTouched();
    }
  }

  setEndDate(event) {
    let localDate = this.budgetingService.convertToLocalTime(event.date * 1000, this.advertiserInfo.marketTimeZone, 'endDate');
    this.endDate.patchValue(localDate);
    if (!this.endDate.touched) {
      this.endDate.markAsTouched();
    }
  }

  //Add budget & flight schedule row.
  addBudget() {
    let newBudget = new FlightScheduleDTO(this.fb);
    this.flightSchedule.push(newBudget.formGroup);
  }

  //Reset entire budget & flight schedule
  resetBudget() {
    this.flightSchedule.controls = [];
    this.addBudget();
  }

  //Clear single control by clicking on "X"
  removeBudget(index: number) {
    this.flightSchedule.removeAt(index);
  }

  get flightSchedule(): FormArray {
    return <FormArray>this.formArray.controls[this.group].get('flightSchedule');
  }

  get budgetFlightSchedule() {
    return this.flightSchedule.controls;
  }

  get startDate(): FormControl {
    return (this.budgetFlightSchedule[0] as FormGroup).controls.startDate as FormControl;
  }

  get endDate(): FormControl {
    return (this.budgetFlightSchedule[0] as FormGroup).controls.endDate as FormControl;
  }

}
